import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ReceivablesInternalARSLScreen from '../Screens/ReceivablesInternalARSLScreen';
import Swal from 'sweetalert2';
import {
  getInternalARSLR,
  requestExportInternalARSLR,
} from '../../../api/ledgers';
import { numberFormatCurrency } from '../../../utils/helper';
import { toast } from 'react-toastify';
import _ from 'lodash';
import useNavActive from '../../../components/Navbar/useNavActive';

const today = new Date();
const prior = new Date().setDate(today.getDate() - 20);
const priorDate = new Date(prior);

const defaultForm = {
  from:
    priorDate.getFullYear() +
    '-' +
    (priorDate.getMonth() + 1) +
    '-' +
    priorDate.getDate(),
  to:
    today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(),
  customer_id: '',
  dr_si_number: null,
  page_size: 50,
  page: 0,
};

const ReceivablesInternalARSL = () => {
  useNavActive([
    'master_databases',
    'sub_ledger_database',
    'internal_ar_sl_receivable',
  ]);
  //declaration
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const [tableData, setTabledata] = useState({
    loading: false,
    data: [],
    totalRows: 0,
  });

  useEffect(() => loadInternalARSLR(form), []);

  const loadInternalARSLR = async (form) => {
    try {
      setTabledata({ ...tableData, loading: true });
      let res = await getInternalARSLR(form);

      const { code, result, total_rows } = res.data;

      if (code !== '00000') {
        throw new Error(result);
        return;
      }

      let data = result.map((row, index) => {
        return {
          id: index,
          customer_code: row.customer_code,
          customer: row.customer,
          transaction: row.transaction,
          transaction_date: row.transaction_date,
          printed_si_no: row.printed_si_no,
          digital_si: row.digital_si,
          dr_number: row.dr_number,
          reference: row.reference,
          particulars: row.particulars,
          debit: row.debit,
          credit: row.credit,
          running_balance: row.running_balance,
          beg_balance: row.beg_balance,
        };
      });

      setTabledata({
        ...tableData,
        loading: false,
        data,
        totalRows: total_rows,
      });
    } catch (error) {
      setTabledata({
        ...tableData,
        loading: false,
        data: [],
        totalRows: 0,
      });
      toast.error('Error occured. Please try again later');
    }
  };

  const handleSelectedTab = (key) => {
    if (key === 'sales_ledger') {
      history.push('/ledgers/sales');
    } else if (key === 'receivables_ledger') {
      history.push('/ledgers/receivables');
    } else if (key === 'inventories_ledger') {
      history.push('/ledgers/inventories');
    } else if (key === 'sales_per_product_ledger') {
      history.push('/ledgers/sales-per-products');
    } else if (key === 'vatable_sales_ledger') {
      history.push('/ledgers/vatable-sales');
    } else if (key === 'product_ledger') {
      history.push('/ledgers/products');
    } else if (key === 'ytd_sales_ledger') {
      history.push('/ledgers/ytd-sales');
    } else if (key === 'internal_ar_sl_receivable') {
      history.push('/ledgers/internal/receivable');
    } else {
      history.push('/ledgers/sales');
    }
  };

  const getDate = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSearch = () => {
    setForm(form);
    loadInternalARSLR(form);
  };

  const handleExport = () => {
    toast.loading('Exporting data in progress, Please wait...', {
      position: toast.POSITION.TOP_RIGHT,
    });
    requestExportInternalARSLR(form)
      .then((res) => {
        console.log({ res });
        if (res.data.code === '00000') {
          console.log(res);
          window.location.href = res.data.result;
          toast.dismiss();
        } else {
          Swal.fire({
            title: 'Error',
            text: res,
            icon: 'error',
          });
        }
      })
      .catch((err) => {});
  };

  const handleTableChange = (params) => {
    const newParams = { ...form, ...params };
    setForm(newParams);

    loadInternalARSLR(newParams);
  };

  return (
    <ReceivablesInternalARSLScreen
      //throw parameter or props.
      formData={form}
      dateChange={getDate}
      handleSearch={handleSearch}
      selectedTab={'internal_ar_sl_receivable'}
      handleSelectedTab={handleSelectedTab}
      loading={loading}
      tableData={tableData}
      handleChange={handleChange}
      handleExport={handleExport}
      handleTableChange={handleTableChange}
    />
  );
};

export default ReceivablesInternalARSL;
